import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import * as yup from 'yup';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { applicationContext } from 'helpers/services';

interface IToolTypologyContext {
    isLoading: boolean
    toolTypology: ToolTypology

    saveToolTypology: (toolTypology: ToolTypology) => void
}

export let toolTypologySchema = yup.object().shape({
    toolTypologyId: yup.string().nullable().default(''),
    name: yup.string().required().default('').label('Nome'),
    needMaintenance: yup.boolean().required().default(false).label('Necessita di Manutenzione'),
    notes: yup.string().nullable().default('').label('Note'),
});

type ToolTypology = yup.InferType<typeof toolTypologySchema>;

export let toolTypologyContext = React.createContext({} as IToolTypologyContext);

let { Provider } = toolTypologyContext;

let ToolTypologyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    let history = useHistory();
    let { enqueueSnackbar } = useSnackbar();

    let appService = useContext(applicationContext);

    let isNew = location.pathname.includes("/addnew");

    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [toolTypology, setToolTypology] = useState<ToolTypology>(toolTypologySchema.getDefault());


    useEffect(() => {
        if (isNew === false)
            getToolTypology();

    }, [id, isNew])

    let getToolTypology = async () => {
        try {
            let res = await axios.get('/api/Tool/GetToolTypology', { params: { toolTypologyId: id } });

            let { item } = res.data;
            setToolTypology({
                ...item,
                adminArea: item.adminArea ?? [],
                groups: item.groups ?? [],
                enabledLocales: item.enabledLocales ?? [],
            });
            setLoading(false);

        } catch (err) { }
        finally {
        }
    }

    let saveToolTypology = async (value: ToolTypology) => {
        if (window.confirm("Vuoi salvare questa Tipologia?")) {
            try {
                await axios.post('/api/Tool/SaveToolTypology', value);
                await appService.getSimecReferenceData();
                
                enqueueSnackbar("Tool Typology saved", { variant: "success" });
                history.push(`/tooltypologies`);
            } catch (err) {
            }
        }
    }


    return (
        <Provider
            value={{
                isLoading,
                toolTypology,

                saveToolTypology
            }}
        >
            {children}
        </Provider>
    )
}

export default ToolTypologyProvider;